import { get, post } from '@/helpers/http';

export function fetchTags(pagination = {}) {
  return get('/tags', { ...pagination });
}

export function fetchFollowed(pagination = {}) {
  return get('/followedTags', { ...pagination });
}

export function fetchTagById(id) {
  return get(`/tags/${id}`);
}

export function searchTag(search) {
  return post('/search/tags', { search });
}

export function getTagUser(tag) {
  return post('/tag/user', { tag });
}

export function followTag(tag) {
  return post('/follow/tag', { tag });
}

export function unfollowTag(tag) {
  return post('/unfollow/tag', { tag });
}

export function saveTag(tag) {
  return post('/tags', { ...tag });
}
